import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_20, COLOR_GRAY_70, COLOR_WHITE, COLOR_GRAY_00 } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  container: {
    background: COLOR_WHITE,
  },
  form: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    width: 'max-content',
    margin: '0 auto',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  input: {
    width: 280,

    '&:first-child': {
      marginBottom: theme.spacing(2),
    },

    [theme.breakpoints.up('md')]: {
      '&:first-child': {
        marginBottom: 0,
        marginRight: theme.spacing(2),
      },
    },

    [theme.breakpoints.down('md')]: {
      boxShadow: '0px 1px 3px -2px #111',
    },
  },
  titleSearch: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2.5),
    flex: 1,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '100%',
      paddingLeft: theme.spacing(0),
    },
  },
  boxContentSearch: {
    background: COLOR_GRAY_20,
    display: 'flex',
    gap: 32,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 80px 8px 0',
    position: 'relative',
    borderRadius: 15,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '24px',
      gap: '24px',
    },
    '& form': {
      width: 420,
      marginRight: 113,
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        marginRight: 0,
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',

        '& div': {
          width: '100%',
        },

        '& .MuiIconButton-edgeEnd': {
          position: 'absolute',
          right: 13,
          top: 6,
        },
      },
    },
    '& h6': {
      color: COLOR_GRAY_70,
      fontFamily: 'Lato',
      fontSize: 18,

      [theme.breakpoints.down('md')]: {
        fontSize: 20,
      },
    },
  },
  boxContentSearchTemplate: {
    [theme.breakpoints.down('md')]: {
      marginBottom: -theme.spacing(4),
    },
  },
  boxContent: {
    background: 'linear-gradient(140deg, #D6246E 0%, #5F29CC 100%)',
    padding: '24px 80px',
    maxWidth: 1226,
    margin: '0 auto',
    borderRadius: 16,
    marginTop: 16,
    '& h6': {
      color: COLOR_WHITE,
      marginBottom: 24,
      fontFamily: 'Lato',
      fontSize: 28,

      [theme.breakpoints.down('md')]: {
        fontSize: 20,
      },
    },

    [theme.breakpoints.down('md')]: {
      padding: '40px 20px',
    },
  },
  inputSearch: {
    width: 420,
    background: COLOR_WHITE,
    left: '50%',
    transform: 'translateX(-50%)',
    position: 'relative',
    borderRadius: 4,
    outline: 'none',

    '& input': {
      width: '100%',
      outline: 'none',
      border: 'none',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, 0px) scale(0.75)',
      display: 'none',
    },

    '& fieldset legend span': {
      display: 'none',
    },

    [theme.breakpoints.down('md')]: {
      width: 280,
    },
  },
  btnBack: {
    display: 'flex',
    gap: 4,
    cursor: 'pointer',
    left: 20,
    top: 28,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      width: '100%',
    },
    '& span': {
      color: COLOR_GRAY_70,
      fontSize: 14,
      fontWeight: 700,
    },
  },
  inputLabel: {
    position: 'absolute',
    top: '-8px',
    left: 10,
    background: COLOR_GRAY_00,
    padding: theme.spacing(0, 0.5),
    zIndex: 1,
    fontSize: '12px',
  },
}));
